var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect, _path29, _rect2, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPneumapass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 325,
    viewBox: "0 0 519 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.5,
    cy: 110.5,
    rx: 11.5,
    ry: 14.5,
    fill: "#B4A088"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.744 1H139.744C186.294 1 224.03 38.7363 224.03 85.2865V323.878H55.4574V85.2865C55.4574 38.7363 93.1937 1 139.744 1Z",
    fill: "#E1F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.232 162.439C187.634 162.439 191.203 158.87 191.203 154.468C191.203 150.066 187.634 146.497 183.232 146.497C178.829 146.497 175.261 150.066 175.261 154.468C175.261 158.87 178.829 162.439 183.232 162.439Z",
    fill: "#0FAFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4574 85.2865C55.4574 38.7363 93.1937 1 139.744 1",
    stroke: "#2F2F2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 323.878H278.488",
    stroke: "#2F2F2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312.981 299.778L321.236 306.947L343.249 278.798L353.155 287.089L405.435 218.345L451.662 299.778L464.32 285.792L487.434 323.742H293.72L312.981 299.778Z",
    fill: "#E1FDF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M494.376 323.742H286.777",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M339.647 180.614C339.647 180.614 256.71 285.898 404.711 282.125L410.581 287.156V251.829L359.87 240.617L365.825 175.631",
    fill: "#0FAFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M361.644 221.258C346.332 222.062 334.071 242.482 334.071 267.56C334.071 268.109 334.079 268.656 334.09 269.201C345.38 276.462 363.041 281.356 389.653 282.119C390.618 277.326 391.099 272.448 391.091 267.56C391.123 260.548 390.112 253.571 388.091 246.856L359.87 240.617L361.644 221.258Z",
    fill: "#2F2F2F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M347.106 182.447C347.106 182.447 341.463 274.547 357.4 318.153L354.071 323.044H382.418C382.418 323.044 385.515 205.898 385.515 180.614L347.106 182.447Z",
    fill: "#0FAFF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M364.5 111C364.776 111 365 110.552 365 110C365 109.448 364.776 109 364.5 109C364.224 109 364 109.448 364 110C364 110.552 364.224 111 364.5 111Z",
    fill: "#2F2F2F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M373.5 111C373.776 111 374 110.552 374 110C374 109.448 373.776 109 373.5 109C373.224 109 373 109.448 373 110C373 110.552 373.224 111 373.5 111Z",
    fill: "#2F2F2F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M363 104H368",
    stroke: "#2F2F2F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M356 108.644V112C354.343 112 353 110.532 353 108.722C353 108.622 353.004 108.522 353.012 108.424C353.18 106.388 356 106.6 356 108.644Z",
    fill: "#B4A088"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M356 112C354.343 112 353 110.657 353 109",
    stroke: "#2F2F2F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M368 117C367.204 117 366.441 116.684 365.879 116.121C365.316 115.559 365 114.796 365 114",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M371 113.029L369 113.971",
    stroke: "#2F2F2F",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M339.647 148.236V180.614L385.515 191.888V155.827C385.515 143.041 376.786 131.906 364.369 128.854H364.369C358.414 127.391 352.117 128.746 347.291 132.529C342.466 136.312 339.647 142.104 339.647 148.236L339.647 148.236Z",
    fill: "#E1FDF7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M347.106 182.447C347.106 182.447 341.463 274.547 357.4 318.153",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M373.087 132.675C373.087 132.675 394.002 146.099 390.089 182.447C386.175 218.796 332.693 172.767 331.202 169.413C329.711 166.059 335.302 163.264 342.197 167.177C342.197 167.177 339.402 164.83 340.706 164.513C342.011 164.195 344.671 165.127 346.136 168.109L378.535 174.072",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M340.578 165.174H308.281L294.119 132.431",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M296.101 135.963L346.136 108.849",
    stroke: "#0FAFF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M345.815 133.809C345.815 133.809 334.351 144.629 330.96 165.174",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M314.99 165.174C314.99 165.174 323.197 188.42 332.72 190.703",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M327.848 165.174C327.848 165.174 323.8 159.537 321.119 158.232C318.437 156.928 310.331 159.909 311.356 161.307C312.381 162.705 314.244 161.959 314.244 161.959C314.244 161.959 313.779 163.357 314.617 163.729",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M493.362 88.8649C493.365 88.7576 493.366 88.6502 493.366 88.5425C493.365 83.4056 490.711 78.6337 486.347 75.9235C481.983 73.2133 476.529 72.9493 471.924 75.2252C464.495 64.3972 451.077 59.3858 438.37 62.693C425.662 66.0003 416.389 76.9169 415.182 89.9924C403.636 93.8517 395.851 104.661 395.85 116.835V116.835C395.85 132.461 408.518 145.128 424.143 145.128H489.079C504.704 145.128 517.371 132.461 517.371 116.835V116.835C517.37 102.863 507.173 90.9832 493.362 88.8649Z",
    fill: "#E1FDF7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M471.924 75.2252C466.115 66.747 456.497 61.6816 446.219 61.6881",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M493.366 88.5424C493.366 84.6026 491.801 80.8241 489.015 78.0382C486.229 75.2522 482.451 73.6871 478.511 73.6871",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M424.143 145.128H489.079C504.704 145.128 517.371 132.461 517.371 116.835",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 471.647,
    y: 177.624,
    width: 30.0727,
    height: 30.0727,
    transform: "rotate(180 471.647 177.624)",
    fill: "#2F2F2F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M479.892 149.818L456.611 126.537L433.329 149.818H479.892Z",
    fill: "#2F2F2F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 471.647,
    y: 236.758,
    width: 30.0727,
    height: 30.0727,
    transform: "rotate(180 471.647 236.758)",
    fill: "#2F2F2F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M479.892 208.952L456.611 185.67L433.329 208.952H479.892Z",
    fill: "#2F2F2F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M471.84 295.777L441.768 296.004L441.541 265.932L471.613 265.705L471.84 295.777Z",
    fill: "#2F2F2F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M479.875 267.909L456.418 244.804L433.313 268.261L479.875 267.909Z",
    fill: "#2F2F2F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M367.793 124.057C372.965 124.203 377.332 118.146 377.547 110.527C377.762 102.909 373.744 96.6145 368.572 96.4684",
    stroke: "#2F2F2F",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M369 109V112",
    stroke: "#2F2F2F",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPneumapass);
export default __webpack_public_path__ + "static/media/pneumapass.4f2c8080146330fe825979354881c8d5.svg";
export { ForwardRef as ReactComponent };